module.exports = __webpack_public_path__ + "img/newicon7.9ef89b6c.svg";